import React from 'react';
import PropTypes from 'prop-types';
import PaymentSupportMessage from './PaymentSupportMessage';
import WssPaymentUpdateForm from './WssPaymentUpdateForm';
import WssOrderAmountSummary from './WssOrderAmountSummary';
import PaymentIssueExplanation from './PaymentIssueExplanation';

function WssPaymentAuthorizationSection({
  orderNumber, wssPaymentDetails, onPaymentError, onPaymentSuccess,
}) {
  if (!wssPaymentDetails || !wssPaymentDetails.paymentUpdateNeeded) {
    return null;
  }

  return (
    <div className="wss-payment-authorization">
      {wssPaymentDetails.showPaymentUpdateForm ? (
        <>
          {/* Payment form section - appears on left on desktop */}
          <div className="wss-payment-form-section">
            <WssPaymentUpdateForm
              orderNumber={orderNumber}
              wssPaymentDetails={wssPaymentDetails}
              onPaymentError={onPaymentError}
              onPaymentSuccess={onPaymentSuccess}
            />
          </div>

          {/* Order summary and explanation - appears on right on desktop */}
          <div className="wss-payment-top-section">
            <WssOrderAmountSummary
              orderTotalText={wssPaymentDetails.orderTotalText}
              amountDueText={wssPaymentDetails.amountDueText}
              orderTotalFormatted={wssPaymentDetails.grandTotalFormatted}
              amountDueFormatted={wssPaymentDetails.authAmountFormatted}
            />
            <PaymentIssueExplanation
              title={wssPaymentDetails.paymentErrorExplanationTitle}
              content={wssPaymentDetails.paymentErrorExplanationContent}
            />
          </div>
        </>
      ) : (
        <PaymentSupportMessage message={wssPaymentDetails.paymentDeclinedMessage} />
      )}
    </div>
  );
}

WssPaymentAuthorizationSection.propTypes = {
  orderNumber: PropTypes.string,
  onPaymentError: PropTypes.func,
  onPaymentSuccess: PropTypes.func,
  wssPaymentDetails: PropTypes.shape({
    paymentUpdateNeeded: PropTypes.bool,
    showPaymentUpdateForm: PropTypes.bool,
    initialErrorBannerMessage: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    orderTotalText: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    amountDueText: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    grandTotalFormatted: PropTypes.string,
    authAmountFormatted: PropTypes.string,
    paymentErrorExplanationTitle: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    paymentErrorExplanationContent: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    paymentDeclinedMessage: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  }),
};

WssPaymentAuthorizationSection.defaultProps = {
  orderNumber: '',
  onPaymentError: undefined,
  onPaymentSuccess: undefined,
  wssPaymentDetails: null,
};

export default WssPaymentAuthorizationSection;
